import React, { useEffect } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import { Link } from "gatsby";
import "./style.css";
import { useCartStore } from "../../../../state/cart";

export default function NavDesktop({ header, navBg }) {
  const { totalQuantity } = useCartStore((state) => state);
  const onScroll = (e) => {
    let scrollValue = window.pageYOffset || e.target.documentElement.scrollTop;

    if (scrollValue < 30) {
      document.getElementById("main-nav").style.top = "0px";
      document.getElementById("main-nav").style.opacity = "1";
    } else if (scrollValue > 150) {
      document.getElementById("main-nav").style.top = "-200px";
      document.getElementById("main-nav").style.opacity = "0";
    }
  };

  useEffect(() => {
    if (window.pageXOffset < 150) {
      document.getElementById("main-nav").style.top = "0px";
      document.getElementById("main-nav").style.opacity = "1";
    }
    window.addEventListener("scroll", onScroll, false);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onMouseLeave = () => {
    document.getElementById("main-nav").style.backgroundColor = navBg;
  };

  const onMouseEnter = () => {
    document.getElementById("main-nav").style.backgroundColor = "black";
  };
  return (
    <div
      className={`fixed top-0 left-0 right-0 py-3 transition-all duration-300 ease-in-out z-10`}
      id="main-nav"
      style={{
        opacity: 0,
        backgroundColor: navBg,
      }}
    >
      <nav className="menu relative">
        <div className="tb-container">
          <div className="max-w-[650px] mx-auto">
            <div className="flex items-center justify-center">
              <ul className="flex  justify-between w-full text-white text-[20px] leading-[30px] font-poppins font-normal">
                {header?.menu?.map((item, index) => {
                  return (
                    <li
                      key={index}
                      className="inline-block"
                      onMouseEnter={onMouseEnter}
                      onMouseLeave={onMouseLeave}
                    >
                      <Link to={item.path}>
                        <span>{item.label}</span>
                      </Link>
                      {item?.childs.length > 0 && (
                        <div className="large-menu" id="large-menu">
                          <div className={`w-full h-full bg-black/90`}>
                            <div className="tb-container py-[52px] px-4 grid grid-cols-3 gap-y-6">
                              {item.childs.map((child, index) => (
                                <Link to={child.path} key={index}>
                                  <div className="flex">
                                    <div>
                                      <GatsbyImage
                                        image={
                                          child?.img?.asset?.gatsbyImageData
                                        }
                                        alt="menu-image"
                                      />
                                    </div>
                                    <div className="ml-[18px] max-w-[213px]">
                                      <p className="text-base text-white font-poppins font-normal underline">
                                        {child.title}
                                      </p>
                                      <p className="text-[15px] mt-[14px] leading-[22px] font-normal font-poppins text-white">
                                        {child.caption}
                                      </p>
                                    </div>
                                  </div>
                                </Link>
                              ))}
                            </div>
                          </div>
                        </div>
                      )}
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
        <Link
          to="/cart"
          className="absolute top-1/2 right-5 -translate-y-1/2 text-white w-5 h-5 z-[11] cursor-pointer"
        >
          <span className="relative">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="currentColor"
              className="size-6"
            >
              <path
                fillRule="evenodd"
                d="M7.5 6v.75H5.513c-.96 0-1.764.724-1.865 1.679l-1.263 12A1.875 1.875 0 0 0 4.25 22.5h15.5a1.875 1.875 0 0 0 1.865-2.071l-1.263-12a1.875 1.875 0 0 0-1.865-1.679H16.5V6a4.5 4.5 0 1 0-9 0ZM12 3a3 3 0 0 0-3 3v.75h6V6a3 3 0 0 0-3-3Zm-3 8.25a3 3 0 1 0 6 0v-.75a.75.75 0 0 1 1.5 0v.75a4.5 4.5 0 1 1-9 0v-.75a.75.75 0 0 1 1.5 0v.75Z"
                clipRule="evenodd"
              />
            </svg>
            {totalQuantity > 0 && (
              <span className="absolute w-4 h-4 -top-2 -right-2 bg-white text-xs rounded-full p-1 text-black flex items-center justify-center text-center">
                {totalQuantity}
              </span>
            )}
          </span>
        </Link>
      </nav>
    </div>
  );
}
